import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { BodyText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsIngredientTitle = (props: Props) => {
  const { children } = props;

  return (
    <BodyText sizeMatch={['18']} style={styles.title}>
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    color: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
